import React from "react";

const UnderConstruction = () => {
  return (
    <div>
      Under construction...
    </div>
  );
};

export default UnderConstruction;